<template>
  <div
    class="div-100 d-flex flex-column align-center justify-center text-center"
  >
    <!-- <v-card-subtitle>
      <h1 v-if="roomState === 'done'" v-html="$t('waitingroom.closed')"></h1>
      <h1
        v-else-if="roomState === 'pause'"
        v-html="$t('waitingroom.pause')"
      ></h1>
      <h1
        v-else-if="roomState === 'upcoming'"
        v-html="$t('waitingroom.title')"
      ></h1>
      <h1 v-else-if="roomState === 'live'">Live</h1>
    </v-card-subtitle> -->

    <v-card flat color="transparent">
      <v-card-subtitle>
        <h1 class="event-waitingroom text-start">{{ $t("waitingroom.title") }}</h1>
      </v-card-subtitle>
      <v-card-text class="d-flex flex-row text-start">
        <h1
          class="event-waitingroom-subtitle"
          v-html="$t('waitingroom.previewvideo')"
        ></h1>
        <v-btn color="primary" class="ml-8 px-5 mx-3 mb-1 align-self-end" large @click="dialog = !dialog">
        <img
          height="28"
          :src="require('_shared/assets/spk__arrow-right.svg')"
        />
      </v-btn>
      </v-card-text>
      
    </v-card>
    <v-dialog v-model="dialog" min-width="50vw" max-width="768">
      <v-card class="d-flex flex-column" color="tertiary">
        <v-responsive :aspect-ratio="16 / 9">
          <iframe
            ref="vimeoplayer"
            :src="link"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
            style="width: 100%; height: 100%"
            class="d-flex"
          ></iframe>
        </v-responsive>        
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Player from "@vimeo/player";

export default { 
  computed: mapState({
    roomState(state, getters) {
       return getters["notification/roomState"];
    },
  }),
  data:()=>({
    dialog: false,
    link: String,
    player: undefined,
  }),
  async beforeCreate() {
    this.link = (
      await this.$axios.get(`/api/webapp/config?clientid=${this.$store.state.client_id}&key=link.vimeo.Preview`)
    ).data.value;
  },
  watch: {
    dialog: {
      handler(val) {
        if (!val) this.player.pause();
        else {
          this.$nextTick(() => {
            if (this.player == undefined)
              this.player = new Player(this.$refs.vimeoplayer);
            else this.player.play();
          });
        }
      },
    },
    roomState: {
      handler(value) {
        if (value === "live") {
          this.$router.replace({
            name: "Live",            
          });
        }
      },
    },
  },
};
</script>

<style scoped>
h1 {
  line-height: 1.35em;
}
p {
  margin: 0px;
}
.event-waitingroom {
  font-family: "Bold";
  font-size: 28px;
  line-height: 2rem;
}

.event-waitingroom-subtitle {
  font-family: "Regular";
  font-size: 18px;  
  line-height: 2rem;
}
</style>